module.exports = __webpack_public_path__ + "static/media/KEC.5282e30d.png";